import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
export const ModelContext = createContext({});
export const ModelProvider = function ({ children }) {
  const [pushEditApi, setPushEditApi] = useState(false);

  //是否變動資料
  const [changeData, setChangeData] = useState(false);

  //是否開啟第一個model
  const [openAskSaveModel, setOpenAskSaveModel] = useState(false);

  //是否要返回清單頁
  const [backListPage, setBackListPage] = useState(true);

  //是否要開啟第二個model
  const [openSecondModel, setOpenSecondModel] = useState(false);

  //開啟第二個model的名字
  const [openSecondModelName, setOpenSecondModelName] = useState("");

  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const changePushEdit = () => {
    if (location.pathname === "/ReferralEditData") {
      setPushEditApi(true);
    }
    setTimeout(() => setPushEditApi(false), 3000);
  };

  return (
    <ModelContext.Provider
      value={{
        pushEditApi,
        setPushEditApi,
        changePushEdit,
        setChangeData,
        changeData,
        openAskSaveModel,
        setOpenAskSaveModel,
        backListPage,
        setBackListPage,
        openSecondModel,
        setOpenSecondModel,
        openSecondModelName,
        setOpenSecondModelName,
        loading,
        setLoading,
      }}
    >
      {children}
    </ModelContext.Provider>
  );
};
